export const PLAYLIST_TYPE = 'PLAYLIST_TYPE';
export const PLAYLIST_TYPE_DETAILS = 'PLAYLIST_TYPE_DETAILS';
export const STORY_TYPE = 'STORY_TYPE';
export const STORY_TYPE_DETAILS = 'STORY_TYPE_DETAILS';
export const SHIELD_TYPE = 'SHIELD_TYPE';
export const SHIELD_TYPE_DETAILS = 'SHIELD_TYPE_DETAILS';
